export const timeFromNow = (time) => Math.floor(Date.now() / 1000) - time;
